import Icon from '@ant-design/icons';

export const createIcon = (Svg: React.FC) => {
  return (
    props: React.ComponentProps<typeof Icon> & React.SVGProps<SVGSVGElement>
  ) => <Icon component={Svg} {...props} />;
};

export default createIcon;
